import { lazy } from "react";

import { PluginManifest } from "@/pluginTypes";

const HomeCareSettingsPage = lazy(() => import("./HomeCareSettingsPage"));

// Wording: public/locale/<lang>.json, loaded by CARE as this plugin's i18n
// namespace (served at /local-plugins/myhis-homedi/locale/).
const manifest: PluginManifest = {
  plugin: "myhis-homedi",
  routes: {
    // "HoMedi home care": the facility's link to HoMedi (managers only).
    "/facility/:facilityId/home-care": ({ facilityId }) => (
      <HomeCareSettingsPage facilityId={facilityId} />
    ),
  },
  components: {
    // The way to that page among the facility home's actions, for managers.
    FacilityHomeActions: lazy(() => import("./HomeCareSettingsButton")),
    // "Refer to home care" among the encounter's actions.
    EncounterActions: lazy(() => import("./ReferButton")),
    // The "Home care" card on the encounter overview and the patient page.
    EncounterOverviewTop: lazy(() => import("./EncounterHomeCareCard")),
    PatientDetailsTabDemographyGeneralInfo: lazy(
      () => import("./PatientHomeCareCard"),
    ),
  },
};

export default manifest;
